import React,{useState} from 'react'
import Logo from "./Images/UCBL logo new.png"
import {FcMenu, FcMinus} from 'react-icons/fc'
import {Link} from 'react-router-dom'
import {
    Nav,  
    NavContainer,  
    LogoHold,  
    MobileIcon,
    NavBar,
    NavLinks 
} 
    from './NavBar.Element'

function Navbar() {
    const [click, setClick] = useState(false);

    const handClick = () => {
        setClick(!click)
    }
  return (
    <>
    <Nav>
        <NavContainer>

            <LogoHold>
                <Link to="/" style={{color:"whitesmoke", textDecoration:"none"}}><img src={Logo} alt='logo'/>  UCBL</Link>
            </LogoHold>

            <MobileIcon onClick={handClick}>
                {click ?<FcMinus />:<FcMenu />}
            </MobileIcon>

            <NavBar onClick={handClick} click={click}>
                <Link to="/standings" style={{color:"white", textDecoration:"none"}}><NavLinks>Standings</NavLinks></Link>
                <Link to="/teams" style={{color:"white", textDecoration:"none"}}><NavLinks>Teams</NavLinks></Link>
                <Link to="/schedule" style={{color:"white", textDecoration:"none"}}><NavLinks>Schedule</NavLinks></Link>
                <Link to="/stats" style={{color:"white", textDecoration:"none"}}><NavLinks>Stats</NavLinks></Link>
                <Link to="/watch" style={{color:"white", textDecoration:"none"}}><NavLinks>Watch</NavLinks></Link>
                <Link to="/draft" style={{color:"white", textDecoration:"none"}}><NavLinks>Drafts</NavLinks></Link>
            </NavBar>
           
        </NavContainer>
    </Nav>
    
    </>     
    
  )
}

export default Navbar